/* src/app/pages/ui-kit/components/pvz-address-input-view/pvz-address-input-view.component.scss */
.box {
  display: flex;
  gap: 14px;
  align-items: flex-start;
  margin-bottom: 30px;
  max-width: 480px;
}
.description {
  margin: 0 0 12px;
  color: var(--text-subtle);
  font-size: 13px;
  max-width: 560px;
}
.value-preview {
  margin: -12px 0 30px;
  max-width: 560px;
}
.value-preview pre {
  margin: 8px 0 0;
  padding: 12px;
  border-radius: 8px;
  background: var(--secondary-subtle-default);
  font-size: 12px;
  overflow-x: auto;
}
/*# sourceMappingURL=pvz-address-input-view.component.css.map */
